export default {
  path: '/Health',
  name: 'HealthCheck',
  component: {
    template: '<div>ok</div>'
  },
  meta: { showSideNav: false }
}
